import React from 'react';
import { connect } from 'react-redux';
import { setVersion } from '@s20/slices/features/common.slice';
import packageJson from '../package.json';

global.appVersion = packageJson.version;

class CacheBuster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false,
            currentVersion: null,
            refreshCacheAndReload: (version) => {
                console.log('Clearing cache and hard reloading...');

                if (localStorage) {
                    localStorage.setItem('appVersion', version);
                }

                if (window.caches) {
                    // Service worker cache should be cleared with caches.delete()
                    window.caches.keys().then((names) => {
                        for (const name of names) {
                            window.caches.delete(name);
                        }
                    });
                }

                // delete browser cache and hard reload
                window.location.reload(true);
            },
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;

        const headers = new Headers();
        headers.append('pragma', 'no-cache');
        headers.append('cache-control', 'no-store');

        fetch('/meta.json', { cache: 'no-store', headers })
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = localStorage ? localStorage.getItem('appVersion') : global.appVersion;
                const shouldForceRefresh = latestVersion !== currentVersion;

                if (shouldForceRefresh) {
                    // console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    this.setState({ loading: false, isLatestVersion: false, currentVersion: latestVersion });
                } else {
                    // console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                    this.setState({ loading: false, isLatestVersion: true, currentVersion: latestVersion });
                }

                dispatch(setVersion(latestVersion));
            });
    }

    render() {
        const {
            loading, isLatestVersion, refreshCacheAndReload, currentVersion,
        } = this.state;
        return this.props.children({
            loading, isLatestVersion, refreshCacheAndReload, currentVersion,
        });
    }
}

export default connect()(CacheBuster);